import React, { useState, useRef } from "react";
import SocialButton from "../social_button";

export default function Dropdown(props) {
    let { url, message, title } = props;
    let [copied, setCopied] = useState(false);
    let copyTimeout = useRef();
    let textInput = useRef();
    let urlAndMessage = message + "\n" + url;

    function getFacebookLink() {
        return "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url);
    }

    function shareOnOther() {
        navigator
            .share({
                title: "DiBook - " + title,
                text: urlAndMessage,
                url: url
            })
            .then(() => console.log("Successful share"))
            .catch(error => console.log("Error sharing", error));
    }

    function getEmailLink() {
        return (
            "mailto:?subject=" +
            encodeURIComponent("DiBook - " + title) +
            "&body=" +
            encodeURIComponent(urlAndMessage)
        );
    }

    function getWhatsappLink() {
        return "https://wa.me?text=" + encodeURIComponent(urlAndMessage);
    }

    return (
        <div
            style={{ display: "block" }}
            className="dropdown-menu dropdown-menu-floating dropdown-menu-share"
            aria-label="Share"
        >
            <div className="popover-container">
                <label style={{ fontWeight: 600 }}>MEGOSZTÁS </label>
                <div className="icon-container1">
                    <SocialButton
                        link={getFacebookLink()}
                        icon="facebook"
                        backgroundColor="#fffff"
                    />
                    <SocialButton
                        link={getWhatsappLink()}
                        icon="whatsapp"
                        backgroundColor="#fffff"
                    />
                    <SocialButton link={getEmailLink()} icon="envelope" backgroundColor="#fffff" />
                    {navigator.share ? (
                        <SocialButton
                            onClickEvent={shareOnOther}
                            icon="share"
                            backgroundColor="#fffff"
                        />
                    ) : null}
                </div>

                <div
                    className="row mt-2 d-flex flex-nowrap align-items-stretch border"
                    style={{ gap: "0.5rem" }}
                >
                    <input
                        ref={textInput}
                        className=""
                        style={{ flex: 1 }}
                        type="url"
                        value={url}
                        readOnly
                    />
                    <button
                        style={{ height: "50px", gap: "1rem" }}
                        className={
                            "btn inline-block d-flex justify-content-between align-items-center " +
                            (copied ? "btn-secondary" : "")
                        }
                        onClick={copy}
                    >
                        {copied ? "Másolva" : "Másolás"}{" "}
                        <i className={copied ? "fas fa-check" : "far fa-clone"}></i>
                    </button>
                </div>
            </div>
        </div>
    );

    function onCopy() {
        if (copyTimeout.current) clearTimeout(copyTimeout.current);
        setCopied(true);
        copyTimeout.current = setTimeout(() => {
            setCopied(false);
        }, 3000);
    }

    function copy() {
        copyFromElement(textInput.current);
        onCopy();
    }

    function copyFromElement(element) {
        element.select();
        element.setSelectionRange(0, 99999);
        if (!navigator.clipboard) {
            try {
                return document.execCommand("copy");
            } catch (e) {
                return false;
            }
        }
        navigator.clipboard.writeText(element.value);
        return true;
    }
}
